import React, { Component } from 'react'
import Included from '../Included'
import commonUI from '../../../js/commonUI';
import DarkThemeNav from '../common/dark-theme-nav';

class Datepicker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      theme: 'default',
    };
    this.initializeDatepickers = this.initializeDarkDatepickers.bind(this);
    this.datePickerIdMap = {
      timepicker: {
        'default': 'timepicker',
        'is-dark': 'timepickerDark',
        'is-dark dark-blue': 'timepickerDarkBlue',
      },
    };
  }

  initializeDarkDatepickers() {
    commonUI.initializeDatepicker('#timepicker', {
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
    });
    commonUI.initializeDatepicker('#timepickerDark', {
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      onReady(index, info, element) {
        element.calendarContainer.classList.add('is-dark');
      },
    });
    commonUI.initializeDatepicker('#timepickerDarkBlue', {
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      onReady(index, info, element) {
        element.calendarContainer.classList.add('is-dark');
        element.calendarContainer.classList.add('dark-blue');
      },
    });
  }

  componentDidUpdate() {
    this.initializeDatepickers();
  }

  render() {
    const { theme } = this.state;
    return (
      <section><a className="anchor" id="datepicker"></a>

        <h2>Date Picker</h2>
        <p>The date picker comes in 3 different formats. Default, Time Picker and Range Selection.</p>

        <DarkThemeNav anchor="datepicker" />

        <div className="soft">
          <h4>Default Date Picker</h4>
          <p>The default date picker with no config will only allow you to select a date.</p>
          <ul className="form-fields">
            <li>
              <label htmlFor="default">Default Date Picker</label>
              <input type="text" className="text-input" id="default" placeholder="Please select date" />
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="fa fa-calendar"></i>
              </div>
            </li>
          </ul>
          <br/>
          <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>
          <pre>
          <code className="language-javascript">{`
            commonUI.initializeDatepicker(\'#default\', {});
          `}</code>
          </pre>
          <br/>
          <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
          <pre className="hide-code"><code className="language-html">{`<ul class="form-fields">
            <li>
              <label for="default">Default Date Picker</label>
              <input type="text" class="text-input" id="default" placeholder="Please select date" />
              <div class="icon__wrapper icon__wrapper--datepicker">
                  <i class="fa fa-calendar"></i>
              </div>
            </li>
          </ul>`}</code></pre>
          <br/>
          <h4>Date Picker with Time Picker</h4>
          <p>The date picker with a time picker will only allow you to select a date followed by the time.</p>
          <ul className="form-fields">
            <li>
              <label htmlFor="timepicker">Date Picker with Time Picker</label>
              <input type="text" className="text-input" id="timepicker" placeholder="Please select date & time" />
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="fa fa-calendar"></i>
              </div>
            </li>
          </ul>
          <br/>
          <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>
          <pre>
          <code className="language-javascript">{`
            commonUI.initializeDatepicker('#timepicker', {
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
            });
          `}</code>
          </pre>
          <br/>
          <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
          <pre className="hide-code"><code className="language-html">{`<ul class="form-fields">
            <li>
              <label for="timepicker">Date Picker with Time Picker</label>
              <input type="text" class="text-input" id="timepicker" placeholder="Please select date & time" />
              <div class="icon__wrapper icon__wrapper--datepicker">
                  <i class="fa fa-calendar"></i>
              </div>
            </li>
          </ul>`}</code></pre>
          <br/>
          <h4>Date Picker with Range</h4>
          <p>The date picker with range will only allow you to select a range of dates.</p>
          <ul className="form-fields">
            <li>
              <label htmlFor="range">Date Picker with Range</label>
              <input type="text" className="text-input" id="range" placeholder="Please select date range" />
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="fa fa-calendar"></i>
              </div>
            </li>
          </ul>
          <br/>
          <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>
          <pre>
            <code className="language-javascript">{`
              commonUI.initializeDatepicker('#range', {
                mode: "range",
              });
            `}</code>
          </pre>
          <br/>
          <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
          <pre className="hide-code"><code className="language-html">{`<ul class="form-fields">
            <li>
              <label for="range">Date Picker with Range</label>
              <input type="text" class="text-input" id="range" placeholder="Please select date range" />
              <div class="icon__wrapper icon__wrapper--datepicker">
                <i class="fa fa-calendar"></i>
              </div>
            </li>
          </ul>`}</code></pre>
          <br/>
          <hr/>
        </div>
        <hr/>
      </section>
    );
  }
}

export default Datepicker;



// WEBPACK FOOTER //
// ./styleguide/components/sections/Datepicker.js